/** Seconds -> "M:SS", or "H:MM:SS" once a solve passes an hour. */
export const formatDuration = (totalSeconds: number): string => {
  const safe = Math.max(0, Math.floor(totalSeconds || 0));
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = safe % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

/** Milliseconds -> "M:SS". */
export const formatDurationMs = (milliseconds: number): string =>
  formatDuration(Math.floor(milliseconds / 1000));

/** "Jul 29, 2026" */
export const formatDate = (value: string): string =>
  new Date(value).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

/** "Tuesday, July 29" — used for the day's headline puzzle. */
export const formatLongDate = (value: string): string =>
  new Date(value).toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
